// Shared formatting helpers for the cash_management pages.
import { torontoToday } from "@utils";

export function fmtDate(s) {
  if (!s) return "—";
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  return d.toLocaleString();
}

export function todayIso() {
  return torontoToday();
}
